export default "__VITE_ASSET__eccfd896__"